export default __webpack_public_path__ + "static/media/2.29b56b3b.mp3";